import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { createPortal } from 'react-dom';
// Importa TODAS as funções da API, incluindo as novas e a URL
import {
    API_URL,
    getCurrentUser,
    getAdSectors,
    getSolicitacoes,
    createSolicitacao,
    updateSolicitacao,
    archiveSolicitation,
    resetarErrosSolicitacoes,
    createUser,
    listUsers,
    backfillUsersFromAd,
    updateUserStatus,
    updateUser // <<< NOVO: Importa a função updateUser
} from './api';
import './App.css'; // Voltamos a usar o App.css original como base
import logo from './assets/logo-onesid.png';
import LoginPage from './LoginPage';

// --- Ícones SVG ---
// (Ícones mantidos como na versão anterior)
const DownloadIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-download" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}> <path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" /> </svg> );
const CopyIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-copy" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}> <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" /> </svg> );
const EllipsisVerticalIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-ellipsis" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}> <path strokeLinecap="round" strokeLinejoin="round" d="M12 5v.01M12 12v.01M12 19v.01M12 6a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2zm0 7a1 1 0 110-2 1 1 0 010 2z" /> </svg> );
const CloseIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-close" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}> <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /> </svg> );
const DetailsIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-details" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"> <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /> </svg> );
const AdminIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-admin" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}> <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" /> <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" /> </svg> );
const EditIcon = () => ( <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-edit" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}> <path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z" /> </svg> );


// --- Funções Auxiliares ---
const APP_TIME_ZONE = 'America/Fortaleza';

const parseAppDate = (rawValue) => {
    if (!rawValue) return null;

    if (rawValue instanceof Date) {
        return Number.isNaN(rawValue.getTime()) ? null : rawValue;
    }

    const value = String(rawValue).trim();
    if (!value) return null;

    const dateOnlyMatch = value.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    }

    const naiveDateTimeMatch = value.match(
        /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})(?::(\d{2})(?:\.(\d{1,6}))?)?$/
    );
    if (naiveDateTimeMatch) {
        const [, year, month, day, hour, minute, second = '0', fractional = '0'] = naiveDateTimeMatch;
        const milliseconds = Number((fractional + '000').slice(0, 3));
        return new Date(
            Date.UTC(
                Number(year),
                Number(month) - 1,
                Number(day),
                Number(hour),
                Number(minute),
                Number(second),
                milliseconds
            )
        );
    }

    const normalizedValue = value.includes(' ') && !value.includes('T')
        ? value.replace(' ', 'T')
        : value;
    const parsed = new Date(normalizedValue);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const formatDataHora = (dataString) => {
    if (!dataString) return 'N/A';
    try {
        const data = parseAppDate(dataString);
        const rawText = String(dataString);
        if (!data) {
            // Fallback para strings de data simples (YYYY-MM-DD) interpretando como UTC
            const parts = rawText.split('-');
            if (parts.length === 3) {
                 const dataOnly = new Date(Date.UTC(parseInt(parts[0]), parseInt(parts[1]) - 1, parseInt(parts[2])));
                 if (!isNaN(dataOnly.getTime())) {
                     // Para datas simples, retorna apenas a data formatada
                     return dataOnly.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
                 }
            }
            console.warn("Formato de data não reconhecido:", dataString);
            return dataString; // Retorna original se não conseguir formatar
        }
        // Verifica se a string original parece ter hora
        if (rawText.includes('T') || rawText.includes(' ')) {
             // Para data/hora completas, fixa o timezone do produto em GMT-3
            return data.toLocaleString('pt-BR', {
                timeZone: APP_TIME_ZONE,
                hour12: false,
            });
        } else {
             // Para strings que são apenas data (mas parseadas com sucesso), retorna só data (UTC)
            return data.toLocaleDateString('pt-BR', { timeZone: 'UTC' }); // Formato só data (considera UTC)
        }
    } catch (e) {
         console.error("Erro formatando data:", dataString, e);
        return dataString; // Retorna original em caso de erro
    }
};

const parseComprovantesPaths = (paths) => {
    try {
        if (!paths) return [];
        if (Array.isArray(paths)) {
            return paths.map(String).filter((path) => path);
        }
        if (typeof paths === 'string' && paths.startsWith('[')) {
            const parsed = JSON.parse(paths);
            return Array.isArray(parsed) ? parsed.map(String).filter((path) => path) : [];
        }
        if (typeof paths === 'string' && paths.trim() !== '') {
            return [paths];
        }
    } catch (error) {
        console.error('Erro ao parsear comprovantes_path:', paths, error);
    }
    return [];
};

const formatValorDisplay = (valor) => {
    if (valor === null || valor === undefined || valor === '') return 'N/A';
    try {
        // Tenta converter string (com ponto ou vírgula) para número
        const num = typeof valor === 'string' ? parseFloat(valor.replace(',', '.')) : parseFloat(valor);
        if (isNaN(num)) {
            console.warn("Valor inválido para formatValorDisplay:", valor);
            return 'Inválido'; // Retorna 'Inválido' se não for número após tentativa
        }
        // Formata como moeda brasileira
        return num.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    } catch (e) {
        console.error("Erro ao formatar valor:", valor, e);
        return 'Erro'; // Retorna 'Erro' em caso de exceção na formatação
    }
};

const normalizeCurrencyString = (rawValue) => {
    if (!rawValue) return '';

    const cleanedValue = String(rawValue).replace(/[^\d,.-]/g, '').trim();
    if (!cleanedValue) return '';

    const hasComma = cleanedValue.includes(',');
    const hasDot = cleanedValue.includes('.');

    if (hasComma && hasDot) {
        return cleanedValue.replace(/\./g, '').replace(',', '.');
    }

    if (hasComma) {
        return cleanedValue.replace(',', '.');
    }

    return cleanedValue;
};

const normalizeDateString = (rawValue) => {
    if (!rawValue) return '';

    const dateValue = String(rawValue).trim();

    const brDateMatch = dateValue.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    if (brDateMatch) {
        const [, day, month, year] = brDateMatch;
        return `${year}-${month}-${day}`;
    }

    const isoDateMatch = dateValue.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateMatch) {
        return dateValue;
    }

    return '';
};

const toFortalezaIsoString = (dateOrDateTimeValue) => {
    if (!dateOrDateTimeValue) return null;

    const dateOnlyMatch = String(dateOrDateTimeValue).match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (dateOnlyMatch) {
        const [, year, month, day] = dateOnlyMatch;
        return `${year}-${month}-${day}T15:00:00-03:00`;
    }

    const dateTimeMatch = String(dateOrDateTimeValue).match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/);
    if (!dateTimeMatch) return null;

    const [, year, month, day, hour, minute] = dateTimeMatch;
    return `${year}-${month}-${day}T${hour}:${minute}:00-03:00`;
};

const EMPTY_SECTOR_FILTER = '__sem_setor__';
const EMPTY_BANK_STATUS_FILTER = '__sem_status_banco__';

const getSolicitacaoSectorValue = (solicitacao) => {
    const rawValue = solicitacao?.setor_criacao || solicitacao?.usuario_criacao?.setor || '';
    return String(rawValue).trim();
};

const getStatusBancoFilterValue = (statusPortal) => {
    const normalizedStatus = String(statusPortal || '').trim();
    return normalizedStatus || EMPTY_BANK_STATUS_FILTER;
};

const getStatusBancoFilterLabel = (statusPortal) => {
    const normalizedStatus = String(statusPortal || '').trim();
    return normalizedStatus || 'Sem retorno do banco';
};

const getBackfillActionLabel = (action) => {
    const labels = {
        update: 'Atualizar',
        no_change: 'Sem alteração',
        not_found: 'Não encontrado',
        no_bb_sector: 'Sem OU BB_',
        skipped: 'Ignorado',
        error: 'Erro',
    };
    return labels[action] || action || 'N/A';
};

const buildPaginationItems = (currentPage, totalPages) => {
    if (totalPages <= 1) return [];

    const pages = new Set([
        1, 2, 3,
        currentPage - 1, currentPage, currentPage + 1,
        totalPages - 2, totalPages - 1, totalPages
    ]);

    const sortedPages = Array.from(pages)
        .filter((page) => page >= 1 && page <= totalPages)
        .sort((a, b) => a - b);

    const items = [];

    sortedPages.forEach((page, index) => {
        const previousPage = sortedPages[index - 1];

        if (index > 0) {
            const gap = page - previousPage;
            if (gap === 2) {
                items.push(previousPage + 1);
            } else if (gap > 2) {
                items.push(`ellipsis-${previousPage}-${page}`);
            }
        }

        items.push(page);
    });

    return items;
};

const buildStaticDownloadUrl = (relativePath) => {
    const baseUrl = API_URL.replace(/\/$/, '');
    const normalizedPath = String(relativePath || '').replace(/^\/+/, '');
    const encodedPath = normalizedPath
        .split('/')
        .filter(Boolean)
        .map((segment) => encodeURIComponent(segment))
        .join('/');

    return `${baseUrl}/static/comprovantes/${encodedPath}`;
};

const getRobotStatusClass = (statusRobo, isArchived = false, isTratado = false) => {
    if (isArchived) return 'archived';
    if (isTratado) return 'finalizado';

    const normalizedStatus = String(statusRobo || 'pendente').toLowerCase();
    if (normalizedStatus.includes('erro')) return 'erro';
    if (normalizedStatus.includes('alerta')) return 'alerta';
    if (normalizedStatus.includes('suspens')) return 'pausado';
    if (normalizedStatus.includes('monitorando')) return 'pendente';
    if (normalizedStatus.includes('finalizado')) return 'finalizado';
    return 'pendente';
};

const getPortalStatusClass = (statusPortal) => {
    const normalizedStatus = String(statusPortal || '').toLowerCase();
    if (!normalizedStatus) return 'neutro';
    if (
        normalizedStatus.includes('cancel') ||
        normalizedStatus.includes('reprov') ||
        normalizedStatus.includes('recus') ||
        normalizedStatus.includes('devolv')
    ) {
        return 'erro';
    }
    if (
        normalizedStatus.includes('efetivad') ||
        normalizedStatus.includes('liquid')
    ) {
        return 'finalizado';
    }
    if (
        normalizedStatus.includes('aguardando') ||
        normalizedStatus.includes('processamento')
    ) {
        return 'pendente';
    }
    return 'neutro';
};

const getPrazoFatalState = (prazoFatalEm, statusRobo) => {
    if (!prazoFatalEm) return 'none';

    const prazoDate = parseAppDate(prazoFatalEm);
    if (Number.isNaN(prazoDate.getTime())) return 'none';

    const robotStatus = String(statusRobo || '').toLowerCase();
    if (robotStatus.includes('finalizado')) return 'safe';

    const now = new Date();
    const diffMs = prazoDate.getTime() - now.getTime();
    if (diffMs <= 0) return 'expired';
    if (diffMs <= 6 * 60 * 60 * 1000) return 'critical';
    if (diffMs <= 24 * 60 * 60 * 1000) return 'warning';
    return 'safe';
};

const splitTabbedLine = (text) => String(text || '')
    .split(/\t+/)
    .map((part) => part.replace(/\s+/g, ' ').trim())
    .filter(Boolean);

const parseSolicitacaoPaste = (text) => {
    const rawText = String(text || '');
    const normalizedText = rawText.replace(/\s+/g, ' ').trim();
    if (!normalizedText) {
        throw new Error('Cole uma linha com os dados para preencher automaticamente.');
    }

    const tabParts = splitTabbedLine(rawText);
    if (tabParts.length >= 6) {
        const [npj, numeroSolicitacao, tribunal, especificacao, statusPortal, dataSolicitacao, ...rest] = tabParts;
        const valorTexto = rest.join(' ').trim();

        return {
            npj: npj || '',
            numeroProcesso: '',
            numeroSolicitacao: numeroSolicitacao || '',
            tribunal: tribunal || '',
            especificacao: especificacao || '',
            statusPortal: statusPortal || '',
            valor: normalizeCurrencyString(valorTexto),
            dataSolicitacao: normalizeDateString(dataSolicitacao || '')
        };
    }

    const processMatch = normalizedText.match(/\d{7}-\d{2}\.\d{4}\.\d(?:\.\d{2})?\.\d{4}/);
    const npjMatch = normalizedText.match(/\b[\d/-]{4,}\b/);

    const solicitationRegexes = [
        /solicita(?:c|ç)(?:a|ã)o[:\s#-]*([A-Za-z0-9./-]{4,})/i,
        /(?:n[º°o.]?\s*)?solicita(?:c|ç)(?:a|ã)o[:\s#-]*([A-Za-z0-9./-]{4,})/i
    ];
    const solicitationMatch = solicitationRegexes
        .map((regex) => normalizedText.match(regex))
        .find(Boolean);

    const currencyMatches = [...normalizedText.matchAll(/\b\d{1,3}(?:\.\d{3})*,\d{2}\b|\b\d+\.\d{2}\b|\b\d+,\d{2}\b/g)];
    const lastCurrency = currencyMatches.length > 0 ? currencyMatches[currencyMatches.length - 1][0] : '';
    const dateMatch = normalizedText.match(/\b\d{2}\/\d{2}\/\d{4}\b|\b\d{4}-\d{2}-\d{2}\b/);

    const fallbackNumbers = normalizedText.match(/\b\d{4,}\b/g) || [];
    const solicitationFallback = fallbackNumbers.find((item) => item !== npjMatch?.[0] && item !== processMatch?.[0]);

    return {
        npj: npjMatch?.[0] || '',
        numeroProcesso: processMatch?.[0] || '',
        tribunal: '',
        especificacao: '',
        statusPortal: '',
        numeroSolicitacao: solicitationMatch?.[1] || solicitationFallback || '',
        valor: normalizeCurrencyString(lastCurrency),
        dataSolicitacao: normalizeDateString(dateMatch?.[0] || '')
    };
};

const normalizeSolicitacaoKeyValue = (value) => String(value || '').trim();

const findDuplicateSolicitacoes = (solicitacoes, npj, numeroSolicitacao) => {
    const normalizedNpj = normalizeSolicitacaoKeyValue(npj);
    const normalizedNumero = normalizeSolicitacaoKeyValue(numeroSolicitacao);

    if (!normalizedNpj || !normalizedNumero) return [];

    return (solicitacoes || [])
        .filter((item) =>
            normalizeSolicitacaoKeyValue(item?.npj) === normalizedNpj &&
            normalizeSolicitacaoKeyValue(item?.numero_solicitacao) === normalizedNumero
        )
        .sort((a, b) => b.id - a.id);
};

const canCurrentUserUpdateSolicitacao = (solicitacao, currentUser) => {
    if (!solicitacao || !currentUser) return false;
    if (solicitacao.can_update === false) return false;
    if (currentUser.role === 'admin') return true;

    const creatorId = solicitacao.usuario_criacao_id ?? solicitacao.usuario_criacao?.id;
    if (creatorId && currentUser.id) {
        return creatorId === currentUser.id;
    }

    const creatorUsername = solicitacao.criado_por || solicitacao.usuario_criacao?.username;
    return creatorUsername === currentUser.username;
};

// --- COMPONENTE DO FORMULÁRIO (SolicitacaoForm) ---
const SolicitacaoForm = ({ onSolicitacaoCriada, existingSolicitacoes = [], currentUser }) => {
    const [linhaCopiada, setLinhaCopiada] = useState('');
    const [parsedSolicitacao, setParsedSolicitacao] = useState(null);
    const [prazoFatal, setPrazoFatal] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState('');
    const [serverDuplicateCandidate, setServerDuplicateCandidate] = useState(null);

    useEffect(() => {
        setServerDuplicateCandidate(null);
        if (!linhaCopiada.trim()) {
            setParsedSolicitacao(null);
            setError('');
            return;
        }

        try {
            const parsed = parseSolicitacaoPaste(linhaCopiada);

            if (!parsed.npj || !parsed.numeroSolicitacao || !parsed.valor || !parsed.dataSolicitacao) {
                throw new Error('Não consegui reconhecer todos os campos obrigatórios da linha: NPJ, número da solicitação, data e valor.');
            }

            setParsedSolicitacao({
                ...parsed,
                aguardandoConfirmacao: true
            });
            setError('');
        } catch (err) {
            setParsedSolicitacao(null);
            setError(err.message || 'Não foi possível interpretar a linha colada.');
        }
    }, [linhaCopiada]);

    const duplicateMatches = useMemo(() => {
        if (!parsedSolicitacao) return [];
        return findDuplicateSolicitacoes(
            existingSolicitacoes,
            parsedSolicitacao.npj,
            parsedSolicitacao.numeroSolicitacao
        );
    }, [existingSolicitacoes, parsedSolicitacao]);

    const duplicateCandidate = serverDuplicateCandidate || duplicateMatches[0] || null;
    const duplicateCount = duplicateCandidate?.duplicate_count || duplicateMatches.length;
    const canUpdateDuplicate = duplicateCandidate
        ? canCurrentUserUpdateSolicitacao(duplicateCandidate, currentUser)
        : false;
    const duplicateCreatorName = duplicateCandidate?.criado_por || duplicateCandidate?.usuario_criacao?.username || 'outro usuário';
    const duplicateNeedsAdjustmentFlow = String(duplicateCandidate?.status_portal || '').toLowerCase().includes('devolvido');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setSuccess('');

        if (!parsedSolicitacao) {
            setError('Cole uma linha válida para confirmar e salvar.');
            setIsLoading(false);
            return;
        }

        let valorFloat;
        try {
             const valorLimpo = parsedSolicitacao.valor.trim().replace(',', '.');
             if (valorLimpo !== '' && !/^\d+([.,]\d{1,2})?$/.test(valorLimpo) ) {
                 throw new Error("Formato de valor inválido. Use 1234.56 ou 1234,56.");
             }
             valorFloat = valorLimpo === '' ? 0.0 : parseFloat(valorLimpo);
             if (isNaN(valorFloat)) {
                 throw new Error("Valor não é um número válido.");
             }
             valorFloat = Math.round(valorFloat * 100) / 100;
        } catch (err) {
            setError(err.message || 'Valor inválido.');
            setIsLoading(false);
            return;
        }

        try {
            const prazoFatalIso = toFortalezaIsoString(prazoFatal);
            const dadosCriacao = {
                npj: parsedSolicitacao.npj.trim(),
                numero_processo: parsedSolicitacao.numeroProcesso?.trim() || null,
                numero_solicitacao: parsedSolicitacao.numeroSolicitacao.trim(),
                especificacao: parsedSolicitacao.especificacao?.trim() || null,
                status_portal: parsedSolicitacao.statusPortal?.trim() || null,
                monitoramento_ativo: true,
                valor: valorFloat,
                data_solicitacao: parsedSolicitacao.dataSolicitacao,
                aguardando_confirmacao: parsedSolicitacao.aguardandoConfirmacao
            };
            if (prazoFatalIso) {
                dadosCriacao.prazo_fatal_em = prazoFatalIso;
            }

            if (duplicateCandidate) {
                if (!canUpdateDuplicate) {
                    setError(`Já existe uma solicitação com esse NPJ e número criada por ${duplicateCreatorName}. Peça ao responsável ou a um administrador para atualizar o registro existente.`);
                    setIsLoading(false);
                    return;
                }

                const dadosAtualizacao = {
                    status_robo: 'Pendente',
                    monitoramento_ativo: true,
                    motivo_encerramento: null,
                    proxima_verificacao_em: null,
                    alerta_enviado_em: null,
                    usuario_confirmacao_id: null,
                    comprovantes_path: [],
                    valor: valorFloat,
                    data_solicitacao: parsedSolicitacao.dataSolicitacao,
                    aguardando_confirmacao: parsedSolicitacao.aguardandoConfirmacao,
                    finalizar: false
                };

                if (parsedSolicitacao.numeroProcesso?.trim()) {
                    dadosAtualizacao.numero_processo = parsedSolicitacao.numeroProcesso.trim();
                }
                if (parsedSolicitacao.especificacao?.trim()) {
                    dadosAtualizacao.especificacao = parsedSolicitacao.especificacao.trim();
                }
                if (parsedSolicitacao.statusPortal?.trim()) {
                    dadosAtualizacao.status_portal = parsedSolicitacao.statusPortal.trim();
                }
                if (prazoFatalIso) {
                    dadosAtualizacao.prazo_fatal_em = prazoFatalIso;
                }

                await updateSolicitacao(duplicateCandidate.id, dadosAtualizacao);
                setSuccess(
                    duplicateCount > 1
                        ? `Solicitação existente atualizada (ID ${duplicateCandidate.id}). Ainda existem ${duplicateCount - 1} registro(s) antigo(s) com essa mesma chave para revisar.`
                        : `Solicitação existente atualizada com sucesso (ID ${duplicateCandidate.id}).`
                );
            } else {
                await createSolicitacao(dadosCriacao);
                setSuccess('Solicitação criada com sucesso!');
            }

            setLinhaCopiada('');
            setParsedSolicitacao(null);
            setPrazoFatal('');
            setServerDuplicateCandidate(null);
            setTimeout(() => setSuccess(''), 3000);
            if(onSolicitacaoCriada) onSolicitacaoCriada();
        } catch (err) {
             const detail = err.response?.data?.detail;
             if (err.response?.status === 409 && detail?.code === 'duplicate_solicitacao') {
                 if (detail.existing_solicitacao) {
                     setServerDuplicateCandidate(detail.existing_solicitacao);
                 }
                 setError(detail.message || 'Já existe uma solicitação com esse NPJ e número. Revise e confirme a atualização do registro existente.');
                 return;
             }
             let message = 'Erro ao criar solicitação.';
             if (typeof detail === 'string') {
                 message += ` ${detail}`;
             } else if (detail && typeof detail === 'object' && detail.message) {
                 message += ` ${detail.message}`;
             } else if (Array.isArray(detail)) {
                 // Formata erros de validação do Pydantic/FastAPI
                 message += ` ${detail.map(d => `${d.loc?.join('/') || 'campo'}: ${d.msg}`).join('; ')}`;
             } else {
                 message += ` ${err.message || 'Verifique os dados.'}`;
             }
            setError(message);
        } finally {
            setIsLoading(false);
        }
    };

    // Layout inline original mantido
    return (
        <div className="card">
            <h2>Adicionar Solicitação</h2>
            <form onSubmit={handleSubmit} className="solicitacao-paste-form">
            <div className="paste-helper">
                <label htmlFor="linhaCopiada">Colar linha completa</label>
                <div className="paste-helper-controls">
                    <textarea
                        id="linhaCopiada"
                        value={linhaCopiada}
                        onChange={(e) => setLinhaCopiada(e.target.value)}
                        placeholder="Cole aqui a linha completa para extrair NPJ, processo, solicitação e valor"
                        rows={2}
                    />
                </div>
                <small className="form-hint">
                    Formato com tabs: NPJ [TAB] Nº Solicitação [TAB] Tribunal [TAB] Especificação [TAB] Status [TAB] Data [TAB] Valor
                </small>
            </div>
            {parsedSolicitacao && (
                <div className="recognized-line">
                    <p className="recognized-line-title">Informacoes reconhecidas para envio</p>
                    <p className="recognized-line-text">
                        <strong>NPJ:</strong> {parsedSolicitacao.npj}
                        {' | '}
                        <strong>Solicitacao:</strong> {parsedSolicitacao.numeroSolicitacao}
                        {parsedSolicitacao.tribunal && (
                            <>
                                {' | '}
                                <strong>Tribunal:</strong> {parsedSolicitacao.tribunal}
                            </>
                        )}
                        {parsedSolicitacao.especificacao && (
                            <>
                                {' | '}
                                <strong>Especificacao:</strong> {parsedSolicitacao.especificacao}
                            </>
                        )}
                        {parsedSolicitacao.statusPortal && (
                            <>
                                {' | '}
                                <strong>Status:</strong> {parsedSolicitacao.statusPortal}
                            </>
                        )}
                        {' | '}
                        <strong>Data:</strong> {formatDataHora(parsedSolicitacao.dataSolicitacao)}
                        {' | '}
                        <strong>Valor:</strong> {formatValorDisplay(parsedSolicitacao.valor)}
                        {' | '}
                        <strong>Status Banco:</strong> {parsedSolicitacao.statusPortal || 'Nao informado'}
                        {' | '}
                        <strong>Status Robo inicial:</strong> Pendente
                        {' | '}
                        <strong>Confirmacao Portal:</strong> Sim
                        {prazoFatal && (
                            <>
                                {' | '}
                                <strong>Prazo Fatal:</strong> {formatDataHora(toFortalezaIsoString(prazoFatal))}
                            </>
                        )}
                    </p>
                </div>
            )}
            {duplicateCandidate && (
                <div className={`recognized-line duplicate-warning-card ${canUpdateDuplicate ? 'is-warning' : 'is-blocked'}`}>
                    <p className="recognized-line-title">
                        {canUpdateDuplicate ? 'Solicitação já cadastrada' : 'Solicitação bloqueada por duplicidade'}
                    </p>
                    <p className="recognized-line-text">
                        Já existe
                        {duplicateCount > 1 ? `m ${duplicateCount} registros` : ' um registro'}
                        {' '}com esse NPJ e número de solicitação.
                        {canUpdateDuplicate
                            ? ` Ao confirmar, vamos atualizar o registro mais recente (ID ${duplicateCandidate.id}) em vez de criar outro.`
                            : ` O registro mais recente é o ID ${duplicateCandidate.id}, criado por ${duplicateCreatorName}.`}
                        {duplicateCandidate.status_portal && ` Último status do banco: ${duplicateCandidate.status_portal}.`}
                        {duplicateNeedsAdjustmentFlow && ' Use esta atualização depois de corrigir e reenviar a solicitação no portal do banco.'}
                    </p>
                </div>
            )}
            <div className="deadline-config-grid">
                <div className="form-group">
                    <label htmlFor="prazoFatal">Prazo fatal para comprovante</label>
                    <input
                        id="prazoFatal"
                        type="date"
                        value={prazoFatal}
                        onChange={(e) => setPrazoFatal(e.target.value)}
                        className="date-input-style"
                    />
                    <small className="form-hint">Horário fixo de comparação: 15:00 do PF no fuso GMT-3 (America/Fortaleza).</small>
                </div>
            </div>
            <div className="submit-row">
                <button
                    type="submit"
                    disabled={isLoading || !parsedSolicitacao || (duplicateCandidate && !canUpdateDuplicate)}
                    className={`button ${duplicateCandidate ? 'warning' : 'primary'} confirm-submit-button`}
                >
                    {isLoading
                        ? 'Enviando...'
                        : duplicateCandidate
                            ? `Atualizar solicitação existente${duplicateCandidate.id ? ` (ID ${duplicateCandidate.id})` : ''}`
                            : 'Confirmar e Enviar Solicitação'}
                </button>
            </div>
            {(error || success) && (
                <div className="form-message-container">
                    {error && <p className="form-message error">{error}</p>}
                    {success && <p className="form-message success">{success}</p>}
                </div>
            )}
            </form>
        </div>
    );
};

// --- COMPONENTES ADMIN ---

// Formulário de Criação de Usuário (UserCreateForm)
// ... (Componente UserCreateForm mantido como no arquivo original)
const UserCreateForm = ({ onUserCreated }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('user'); // Default 'user'
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!username.trim() || !password.trim()) {
            setError('Usuário e senha são obrigatórios.');
            return;
        }
        setIsLoading(true);
        setError('');
        setSuccess('');

        try {
            await createUser({ username: username.trim(), password, role });
            setSuccess(`Usuário '${username.trim()}' criado com sucesso!`);
            setUsername('');
            setPassword('');
            setRole('user');
            setTimeout(() => setSuccess(''), 4000);
            if(onUserCreated) onUserCreated(); // Avisa o painel admin para recarregar a lista
        } catch (err) {
             const message = err.response?.data?.detail || err.message || 'Erro desconhecido.';
            setError(`Erro ao criar usuário: ${message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="admin-user-create-form"> {/* Classe CSS específica */}
            <div className="form-group">
                <label htmlFor="newUsername">Novo Usuário:</label>
                <input id="newUsername" type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Nome de usuário" required />
            </div>
            <div className="form-group">
                <label htmlFor="newPassword">Senha:</label>
                <input id="newPassword" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Senha" required />
            </div>
            <div className="form-group">
                <label htmlFor="newRole">Permissão:</label>
                <select id="newRole" value={role} onChange={(e) => setRole(e.target.value)} required>
                    <option value="user">Usuário</option>
                    <option value="admin">Admin</option>
                </select>
            </div>
            <button type="submit" disabled={isLoading} className="button primary small">
                {isLoading ? 'Criando...' : 'Criar Usuário'}
            </button>
            {error && <p className="form-message error">{error}</p>}
            {success && <p className="form-message success">{success}</p>}
        </form>
    );
};

// Tabela de Lista de Usuários (UserListTable)
// ... (Componente UserListTable mantido como no arquivo original, incluindo botão Editar)
const UserListTable = ({ users: initialUsers = [], currentUser, onUserListChanged, onEditUser }) => {
    const [users, setUsers] = useState(initialUsers);
    const [loadingStates, setLoadingStates] = useState({}); // { userId: boolean } - Para ativar/desativar
    const [error, setError] = useState('');

    // Atualiza a lista local se a prop mudar
    useEffect(() => {
        setUsers(initialUsers);
    }, [initialUsers]);

    const handleToggleActive = async (userToUpdate) => {
        // Impede admin de desativar a si mesmo ou o usuário 'admin' principal, mas permite reativar
        if ((userToUpdate.id === currentUser.id || userToUpdate.username === 'admin') && !userToUpdate.is_active === false) {
             setError("Não é possível desativar a si mesmo ou o usuário 'admin'.");
             setTimeout(() => setError(''), 4000);
             return;
        }

        const newStatus = !userToUpdate.is_active;
        setLoadingStates(prev => ({ ...prev, [userToUpdate.id]: true }));
        setError('');

        try {
            await updateUserStatus(userToUpdate.id, newStatus);
            // Atualiza a lista localmente para refletir a mudança imediatamente
            setUsers(prevUsers => prevUsers.map(u =>
                u.id === userToUpdate.id ? { ...u, is_active: newStatus } : u
            ));
            // Opcional: Chamar onUserListChanged() se precisar recarregar do backend
            // if(onUserListChanged) onUserListChanged();
        } catch (err) {
            setError(`Erro ao ${newStatus ? 'ativar' : 'desativar'} usuário: ${err.response?.data?.detail || err.message}`);
             setTimeout(() => setError(''), 5000); // Limpa erro após 5s
        } finally {
            setLoadingStates(prev => ({ ...prev, [userToUpdate.id]: false }));
        }
    };

    return (
        <div className="admin-user-list-container">
            {error && <p className="form-message error">{error}</p>}
            <div className="table-wrapper">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Username</th>
                            <th>Setor</th>
                            <th>Origem</th>
                            <th>Role</th>
                            <th>Status</th>
                            <th style={{ textAlign: 'center' }}>Ações</th> {/* Centraliza cabeçalho Ações */}
                        </tr>
                    </thead>
                    <tbody>
                        {users.length > 0 ? (
                            users.map(user => {
                                const isLoadingToggle = loadingStates[user.id];
                                // Condição para desabilitar o botão de ativar/desativar
                                const isToggleDisabled = isLoadingToggle || ((user.id === currentUser.id || user.username === 'admin') && user.is_active);
                                // Condição para desabilitar botão de editar (não pode editar admin principal)
                                const isEditDisabled = user.username === 'admin';

                                return (
                                    <tr key={user.id}>
                                        <td>{user.id}</td>
                                        <td>{user.username}</td>
                                        <td>{user.setor || 'Sem setor'}</td>
                                        <td>{user.auth_provider === 'ad' ? 'AD' : 'Local'}</td>
                                        <td>{user.role}</td>
                                        <td>{user.is_active ? 'Ativo' : 'Inativo'}</td>
                                        <td style={{ textAlign: 'center' }}> {/* Centraliza botões */}
                                            {/* Botão Editar */}
                                            <button
                                                onClick={() => onEditUser(user)}
                                                disabled={isEditDisabled}
                                                className="button small action-button button-edit" // Usa classe genérica e específica
                                                title={isEditDisabled ? "Não pode editar o usuário 'admin'" : 'Editar usuário'}
                                            >
                                                <EditIcon /> {/* Ícone de Edição */}
                                            </button>
                                            {/* Botão Ativar/Desativar */}
                                            <button
                                                onClick={() => handleToggleActive(user)}
                                                disabled={isToggleDisabled}
                                                className={`button small action-button ${user.is_active ? 'button-deactivate' : 'button-activate'}`}
                                                title={isToggleDisabled ? "Não pode alterar status" : (user.is_active ? 'Desativar usuário' : 'Ativar usuário')}
                                                style={{ marginLeft: '0.5rem' }} // Adiciona espaço entre botões
                                            >
                                                {isLoadingToggle ? '...' : (user.is_active ? 'Desativar' : 'Ativar')}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr><td colSpan="7" className="table-empty-message">Nenhum outro usuário encontrado.</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

// Componente Modal de Edição de Usuário (UserEditModal)
// ... (Componente UserEditModal mantido exatamente como está)
const UserEditModal = ({ userToEdit, onClose, onUserUpdated }) => {
    const [username, setUsername] = useState(userToEdit.username);
    const [password, setPassword] = useState(''); // Começa vazio
    const [role, setRole] = useState(userToEdit.role);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Previne edição do username 'admin'
    const isUsernameAdmin = userToEdit.username === 'admin';

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');
        setSuccess('');

        const updateData = {};
        if (!isUsernameAdmin && username.trim() && username.trim() !== userToEdit.username) {
            updateData.username = username.trim();
        }
        if (password.trim()) { // Só envia senha se algo for digitado
            updateData.password = password;
        }
        if (role !== userToEdit.role) {
            updateData.role = role;
        }

        if (Object.keys(updateData).length === 0) {
            setError('Nenhuma alteração detectada.');
            setIsLoading(false);
            return;
        }

        try {
            await updateUser(userToEdit.id, updateData);
            setSuccess('Usuário atualizado com sucesso!');
            // Limpa senha após sucesso
            setPassword('');
            setTimeout(() => {
                 setSuccess('');
                 if(onUserUpdated) onUserUpdated(); // Chama a função para recarregar a lista no AdminPanel
                 onClose(); // Fecha o modal
            }, 2000);
        } catch (err) {
            const detail = err.response?.data?.detail;
             let message = 'Erro ao atualizar usuário.';
             if (typeof detail === 'string') {
                 message += ` ${detail}`;
             } else if (Array.isArray(detail)) {
                 message += ` ${detail.map(d => `${d.loc?.join('/') || 'campo'}: ${d.msg}`).join('; ')}`;
             } else {
                 message += ` ${err.message || 'Verifique os dados.'}`;
             }
            setError(message);
        } finally {
            setIsLoading(false);
        }
    };

    return createPortal(
        <div className="modal-backdrop" onClick={onClose}>
            <div className="modal-content admin-modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                     <h3>Editar Usuário (ID: {userToEdit.id})</h3>
                     <button onClick={onClose} className="modal-action-button modal-close-icon-button" title="Fechar" disabled={isLoading}><CloseIcon /></button>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        {error && <p className="form-message error modal-error">{error}</p>}
                        {success && <p className="form-message success modal-success">{success}</p>}

                        <div className="form-group">
                            <label htmlFor="editUsername">Username:</label>
                            <input
                                id="editUsername"
                                type="text"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                placeholder="Nome de usuário"
                                required
                                disabled={isUsernameAdmin} // Desabilita se for 'admin'
                                title={isUsernameAdmin ? "Não é possível alterar o nome do usuário 'admin'" : ""}
                            />
                             {isUsernameAdmin && <small className="form-hint">O nome do usuário 'admin' não pode ser alterado.</small>}
                        </div>
                        <div className="form-group">
                            <label htmlFor="editPassword">Nova Senha:</label>
                            <input
                                id="editPassword"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Deixe em branco para manter a atual"
                            />
                            <small className="form-hint">Mínimo 4 caracteres se for alterar.</small>
                        </div>
                        <div className="form-group">
                            <label htmlFor="editRole">Permissão:</label>
                            <select
                                id="editRole"
                                value={role}
                                onChange={(e) => setRole(e.target.value)}
                                required
                                disabled={isUsernameAdmin} // Não pode mudar a role do 'admin'
                                title={isUsernameAdmin ? "Não é possível alterar a permissão do usuário 'admin'" : ""}
                            >
                                <option value="user">Usuário</option>
                                <option value="admin">Admin</option>
                            </select>
                            {isUsernameAdmin && <small className="form-hint">A permissão do usuário 'admin' não pode ser alterada.</small>}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" onClick={onClose} className="button secondary small" disabled={isLoading}>Cancelar</button>
                        <button type="submit" disabled={isLoading} className="button primary small">
                            {isLoading ? 'Salvando...' : 'Salvar Alterações'}
                        </button>
                    </div>
                </form>
            </div>
        </div>,
        document.getElementById('modal-root')
    );
};

const AdBackfillPanel = ({ onBackfillApplied }) => {
    const [report, setReport] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [runningMode, setRunningMode] = useState('preview');

    const runBackfill = async (dryRun) => {
        setIsLoading(true);
        setRunningMode(dryRun ? 'preview' : 'apply');
        setError('');
        setSuccess('');

        try {
            const result = await backfillUsersFromAd(dryRun);
            setReport(result);

            if (dryRun) {
                setSuccess(
                    `Prévia concluída: ${result.summary?.atualizaveis || 0} usuário(s) podem ser sincronizados com o AD.`
                );
            } else {
                setSuccess(
                    `Backfill aplicado: ${result.summary?.atualizados || 0} usuário(s) atualizados e promovidos para autenticação via AD.`
                );
                if (onBackfillApplied) {
                    onBackfillApplied();
                }
            }
        } catch (err) {
            const detail = err.response?.data?.detail || err.message;
            setError(`Falha no backfill AD: ${detail}`);
        } finally {
            setIsLoading(false);
        }
    };

    const handleApply = async () => {
        if (!window.confirm("Aplicar o backfill agora? Usuários sincronizados passarão a exigir autenticação via AD.")) {
            return;
        }
        await runBackfill(false);
    };

    const canApplyBackfill = !isLoading && (
        !report ||
        (report.summary?.atualizaveis || 0) > 0
    );

    return (
        <section className="admin-section">
            <h4>Backfill de Usuários Locais via AD</h4>
            <p className="admin-backfill-description">
                Faz a conciliação por <strong>username</strong>, atualiza o setor a partir do Active Directory
                e converte os usuários encontrados para origem <strong>AD</strong>, bloqueando o fallback local.
            </p>
            <div className="admin-actions-container">
                <button
                    onClick={() => runBackfill(true)}
                    disabled={isLoading}
                    className="button secondary small"
                >
                    {isLoading && runningMode === 'preview' ? 'Gerando prévia...' : 'Prévia do Backfill'}
                </button>
                <button
                    onClick={handleApply}
                    disabled={!canApplyBackfill}
                    className="button primary small"
                >
                    {isLoading && runningMode === 'apply' ? 'Aplicando...' : 'Aplicar Backfill'}
                </button>
            </div>
            {error && <p className="form-message error">{error}</p>}
            {success && <p className="form-message success">{success}</p>}

            {report?.summary && (
                <div className="admin-backfill-summary">
                    <div className="admin-backfill-stat"><span>Locais</span><strong>{report.summary.usuarios_locais || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Candidatos</span><strong>{report.summary.candidatos || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Atualizáveis</span><strong>{report.summary.atualizaveis || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Atualizados</span><strong>{report.summary.atualizados || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Sem alteração</span><strong>{report.summary.sem_alteracao || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Não encontrados</span><strong>{report.summary.nao_encontrados || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Sem OU BB_</span><strong>{report.summary.sem_setor_bb || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Ignorados</span><strong>{report.summary.ignorados || 0}</strong></div>
                    <div className="admin-backfill-stat"><span>Erros</span><strong>{report.summary.erros || 0}</strong></div>
                </div>
            )}

            {report?.results?.length > 0 && (
                <div className="admin-backfill-results">
                    <div className="table-wrapper">
                        <table>
                            <thead>
                                <tr>
                                    <th>Username</th>
                                    <th>Origem</th>
                                    <th>Setor atual</th>
                                    <th>Setor AD</th>
                                    <th>Ação</th>
                                    <th>Detalhe</th>
                                </tr>
                            </thead>
                            <tbody>
                                {report.results.map((row) => (
                                    <tr key={`${row.username}-${row.action}`}>
                                        <td>{row.username}</td>
                                        <td>{row.auth_provider === 'ad' ? 'AD' : 'Local'}</td>
                                        <td>{row.current_setor || 'Sem setor'}</td>
                                        <td>{row.ad_setor || 'N/A'}</td>
                                        <td>{getBackfillActionLabel(row.action)}</td>
                                        <td>{row.detail || 'N/A'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </section>
    );
};

// Componente do Painel de Administração (AdminPanelModal)
// <<< AJUSTES: Adiciona handlers para abrir/fechar UserEditModal >>>
const AdminPanelModal = ({ currentUser, onDataRefresh, isOpen, onClose }) => {
    const [users, setUsers] = useState([]);
    const [isLoadingUsers, setIsLoadingUsers] = useState(false);
    const [userListError, setUserListError] = useState('');
    const [showArchived, setShowArchived] = useState(false); // Estado para ver arquivados
    const [isResettingErrors, setIsResettingErrors] = useState(false);
    const [resetError, setResetError] = useState('');
    const [resetSuccess, setResetSuccess] = useState('');

    // <<< NOVO: Estados para controlar o modal de edição >>>
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState(null); // Guarda o usuário sendo editado

    const fetchUsers = useCallback(async () => {
        setIsLoadingUsers(true);
        setUserListError('');
        try {
            const userList = await listUsers();
            setUsers(userList);
        } catch (err) {
            setUserListError('Erro ao carregar lista de usuários: ' + (err.response?.data?.detail || err.message));
        } finally {
            setIsLoadingUsers(false);
        }
    }, []); // useCallback para evitar recriação desnecessária

    // Carrega usuários ao abrir o modal principal
    useEffect(() => {
        if (isOpen) {
            fetchUsers();
            // Também reseta o estado do checkbox 'showArchived' ao abrir,
            // ou busca o estado inicial dos filtros do App se necessário.
            // Por simplicidade, vamos resetar para false:
            setShowArchived(false);
        }
    }, [isOpen, fetchUsers]);

    // Função para recarregar a lista de usuários (chamada pelo UserCreateForm E UserEditModal)
    const refreshUserList = () => {
        fetchUsers();
    };

     // Função para o botão de resetar erros
     const handleResetErrors = async () => {
        setIsResettingErrors(true);
        setResetError('');
        setResetSuccess('');
        try {
            const result = await resetarErrosSolicitacoes();
            setResetSuccess(result.message || 'Status de erro resetados com sucesso.');
            if(onDataRefresh) onDataRefresh(showArchived, null); // Atualiza lista de solicitações (sem filtro de user aqui)
            setTimeout(() => setResetSuccess(''), 5000);
        } catch (err) {
             setResetError('Erro ao resetar status: ' + (err.response?.data?.detail || err.message));
        } finally {
            setIsResettingErrors(false);
        }
    };

    // Callback para o checkbox de arquivados
    const handleShowArchivedChange = (e) => {
        const checked = e.target.checked;
        setShowArchived(checked);
        if(onDataRefresh) onDataRefresh(checked, null); // Pede para App.js recarregar (sem filtro de user aqui)
    };

    // <<< NOVO: Funções para abrir e fechar o modal de edição >>>
    const openEditModal = (user) => {
        console.log("Abrindo modal de edição para:", user);
        setEditingUser(user);
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        console.log("Fechando modal de edição.");
        setIsEditModalOpen(false);
        setEditingUser(null);
    };

    // <<< NOVO: Função chamada pelo UserEditModal após sucesso >>>
    const handleUserUpdated = () => {
        console.log("Usuário atualizado, recarregando lista...");
        refreshUserList(); // Recarrega a lista de usuários no painel admin
        // O modal de edição se fecha sozinho após o timeout de sucesso
    };


    if (!isOpen) return null; // Não renderiza nada se fechado

    return createPortal(
        <> {/* Usa Fragment para permitir múltiplos modais no portal */}
            <div className="modal-backdrop" onClick={onClose}>
                <div className="modal-content admin-modal-content" onClick={e => e.stopPropagation()}>
                    <div className="modal-header">
                         <h3>Painel Administrativo</h3>
                         <button onClick={onClose} className="modal-action-button modal-close-icon-button" title="Fechar"><CloseIcon /></button>
                    </div>
                    <div className="modal-body">
                        <section className="admin-section">
                            <h4>Gerenciar Usuários</h4>
                            {/* Passa refreshUserList para o formulário de criação */}
                            <UserCreateForm onUserCreated={refreshUserList} />
                            {userListError && <p className="form-message error">{userListError}</p>}
                            {isLoadingUsers ? <p>Carregando...</p> : (
                                // Passa refreshUserList e openEditModal para a tabela
                                <UserListTable
                                    users={users}
                                    currentUser={currentUser}
                                    onUserListChanged={refreshUserList}
                                    onEditUser={openEditModal} // <<< NOVO >>>
                                />
                            )}
                        </section>
                        <hr className="modal-divider"/>
                        <AdBackfillPanel onBackfillApplied={refreshUserList} />
                         <hr className="modal-divider"/>
                        <section className="admin-section">
                             <h4>Ações Gerais</h4>
                             <div className="admin-actions-container">
                                 <div className="checkbox-container">
                                    <input
                                        type="checkbox"
                                        id="showArchivedAdmin" // ID único para o checkbox no modal
                                        checked={showArchived}
                                        onChange={handleShowArchivedChange}
                                    />
                                    <label htmlFor="showArchivedAdmin"> Exibir arquivadas na tabela principal</label>
                                </div>
                                <button
                                    onClick={handleResetErrors}
                                    disabled={isResettingErrors}
                                    className="button warning small" // Estilo ajustado
                                 >
                                     {isResettingErrors ? 'Resetando...' : 'Resetar Erros'}
                                </button>
                             </div>
                            {resetError && <p className="form-message error">{resetError}</p>}
                            {resetSuccess && <p className="form-message success">{resetSuccess}</p>}
                        </section>
                    </div>
                </div>
            </div>

            {/* <<< NOVO: Renderiza o Modal de Edição condicionalmente >>> */}
            {isEditModalOpen && editingUser && (
                <UserEditModal
                    userToEdit={editingUser}
                    onClose={closeEditModal}
                    onUserUpdated={handleUserUpdated}
                />
            )}
        </>,
        document.getElementById('modal-root')
    );
};
// --- FIM COMPONENTES ADMIN ---

// --- COMPONENTE DA TABELA DE SOLICITAÇÕES ---
const SolicitacoesTable = ({ solicitacoes: allSolicitacoes, currentUser, onDataRefresh, currentFilters }) => {
    // ... (states, refs, lógicas de filtro e paginação mantidas) ...
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedSolicitacao, setSelectedSolicitacao] = useState(null);
    const [isModalLoading, setIsModalLoading] = useState(false);
    const [modalError, setModalError] = useState('');
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [copyStatus, setCopyStatus] = useState('');
    const isAdmin = currentUser?.role === 'admin';
    const menuRef = useRef(null); // Ref para fechar dropdown

    // --- Estados para Filtros ---
    const [filterNpj, setFilterNpj] = useState('');
    const [filterProcesso, setFilterProcesso] = useState('');
    const [filterStartDate, setFilterStartDate] = useState('');
    const [filterEndDate, setFilterEndDate] = useState('');
    const [filterStatusBanco, setFilterStatusBanco] = useState('all');

    // --- Estados para Paginação ---
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);

    const availableStatusBanco = useMemo(() => {
        const uniqueStatuses = new Set();

        allSolicitacoes.forEach((item) => {
            uniqueStatuses.add(getStatusBancoFilterValue(item.status_portal));
        });

        return Array.from(uniqueStatuses)
            .sort((left, right) => {
                if (left === EMPTY_BANK_STATUS_FILTER) return -1;
                if (right === EMPTY_BANK_STATUS_FILTER) return 1;
                return left.localeCompare(right, 'pt-BR');
            })
            .map((statusValue) => ({
                value: statusValue,
                label: getStatusBancoFilterLabel(statusValue === EMPTY_BANK_STATUS_FILTER ? '' : statusValue)
            }));
    }, [allSolicitacoes]);

    // --- Filtragem ---
    const filteredSolicitacoes = useMemo(() => {
        return allSolicitacoes.filter(item => {
            const npjMatch = filterNpj ? item.npj?.toLowerCase().includes(filterNpj.toLowerCase()) : true;
            const processoMatch = filterProcesso ? item.numero_processo?.toLowerCase().includes(filterProcesso.toLowerCase()) : true;
            const statusBancoValue = getStatusBancoFilterValue(item.status_portal);
            const statusBancoMatch = filterStatusBanco === 'all' ? true : statusBancoValue === filterStatusBanco;

            let sectorMatch = true;
            if (isAdmin && currentFilters.userFilter === 'sector') {
                const selectedSector = currentFilters.selectedSector || '';
                const itemSectorValue = getSolicitacaoSectorValue(item);
                sectorMatch = selectedSector
                    ? (selectedSector === EMPTY_SECTOR_FILTER ? !itemSectorValue : itemSectorValue === selectedSector)
                    : true;
            }

            let dateMatch = true;
            if (filterStartDate || filterEndDate) {
                try {
                    // Garante que a data seja tratada como UTC
                    const itemDate = item.data_solicitacao ? new Date(item.data_solicitacao + 'T00:00:00Z') : null;

                    // Se a data do item for inválida, considera que não bate se algum filtro de data estiver ativo
                    if (!itemDate || isNaN(itemDate.getTime())) {
                        dateMatch = !(filterStartDate || filterEndDate);
                    } else {
                        if (filterStartDate) {
                            const startDate = new Date(filterStartDate + 'T00:00:00Z');
                            if (itemDate < startDate) dateMatch = false;
                        }
                        if (filterEndDate) {
                            const endDate = new Date(filterEndDate + 'T00:00:00Z');
                            // Ajusta endDate para incluir o dia inteiro
                            endDate.setUTCDate(endDate.getUTCDate() + 1);
                            if (itemDate >= endDate) dateMatch = false;
                        }
                    }
                } catch (e) {
                    console.error("Erro ao comparar datas:", e);
                    dateMatch = true; // Ignora filtro de data se houver erro
                }
            }

            return npjMatch && processoMatch && statusBancoMatch && sectorMatch && dateMatch;
        });
    }, [allSolicitacoes, currentFilters.selectedSector, currentFilters.userFilter, filterEndDate, filterNpj, filterProcesso, filterStartDate, filterStatusBanco, isAdmin]);

     // --- Paginação ---
    const totalPages = Math.max(1, Math.ceil(filteredSolicitacoes.length / itemsPerPage));
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentSolicitacoes = filteredSolicitacoes.slice(indexOfFirstItem, indexOfLastItem);
    const paginationItems = buildPaginationItems(currentPage, totalPages);

    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    const handleNextPage = () => paginate(currentPage + 1);
    const handlePrevPage = () => paginate(currentPage - 1);
    const handleItemsPerPageChange = (event) => {
        const nextItemsPerPage = parseInt(event.target.value, 10);
        setItemsPerPage(nextItemsPerPage);
        setCurrentPage(1);
    };

    // Reset page number when filters change externally (via props) or internally
    useEffect(() => {
        setCurrentPage(1);
    }, [currentFilters, filterEndDate, filterNpj, filterProcesso, filterStartDate, filterStatusBanco, itemsPerPage]);


    // Fechar Menu Dropdown ao clicar fora
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Função interna para chamar onDataRefresh com os filtros atuais
    const triggerRefresh = () => {
         if (onDataRefresh) {
             onDataRefresh(currentFilters.includeArchived, currentFilters.userFilter);
         }
    };

    // Funções do Modal
    const openModal = (solicitacao) => {
        setSelectedSolicitacao(solicitacao);
        setIsModalOpen(true);
        setModalError('');
        setIsMenuOpen(false); // Fecha menu ao abrir modal
        setCopyStatus(''); // Limpa status de cópia
    };

    const closeModal = () => {
        if (isModalLoading) return; // Não fecha se estiver carregando
        setIsModalOpen(false);
        setSelectedSolicitacao(null);
    };

    const toggleMenu = (e) => {
        e.stopPropagation(); // Impede que o clique feche o modal
        setIsMenuOpen(!isMenuOpen);
    };

    // Função Copiar
    const handleCopyToClipboard = (text) => {
        if (!text) {
             setCopyStatus('Nada copiado');
             setTimeout(() => setCopyStatus(''), 2000);
             return;
        }
        try {
            // Cria um elemento temporário para copiar
            const ta = document.createElement("textarea");
            ta.value = text;
            ta.style.position = 'fixed'; // Impede de piscar
            ta.style.left = '-9999px'; // Fora da tela
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy'); // Usa execCommand por compatibilidade com iframe
            document.body.removeChild(ta);
            setCopyStatus('Copiado!');
            setTimeout(() => setCopyStatus(''), 1500); // Mensagem mais rápida
        } catch (err) {
            console.error('Falha ao copiar:', err);
            setCopyStatus('Falhou!');
            setTimeout(() => setCopyStatus(''), 1500);
        }
    };

    // Função para formatar lista de comprovantes/documentos
    const formatComprovantes = (paths) => {
        const links = parseComprovantesPaths(paths);
        if (!Array.isArray(links) || links.length === 0) return <li className="modal-no-files">Nenhum</li>;

        return links.map((link, index) => {
            const nomeArquivo = link.split(/[\\/]/).pop() || `Arquivo ${index + 1}`;
            const downloadUrl = buildStaticDownloadUrl(link);


            // Determina o tipo pelo nome (heurística)
            let tipo = 'Documento';
            if (nomeArquivo.toLowerCase().includes('comprovante') || nomeArquivo.toLowerCase().includes('boleto')) {
                tipo = 'Comprovante';
            } else if (nomeArquivo.toLowerCase().endsWith('.png') || nomeArquivo.toLowerCase().endsWith('.jpg')) {
                tipo = 'Screenshot'; // Identifica screenshots
            }
            // Adicione outras heurísticas se necessário (ex: 'guia', 'custas')

            return (
                <li key={index}>
                    <a href={downloadUrl} target="_blank" rel="noopener noreferrer" download={nomeArquivo}
                       className="modal-file-link group" title={`Baixar: ${nomeArquivo}`}>
                        {tipo}
                        <DownloadIcon />
                    </a>
                </li>
            );
        });
    };

    // --- Ações do Modal ---
    const handleResetPendente = async () => {
        if (!selectedSolicitacao || isModalLoading) return;
        setIsModalLoading(true);
        setModalError('');
        setIsMenuOpen(false); // Fecha menu
        console.log(`[SolicitacoesTable] Resetando solicitação ID ${selectedSolicitacao.id} para Pendente...`);
        try {
            await updateSolicitacao(selectedSolicitacao.id, {
                status_robo: "Pendente",
                status_portal: null,
                usuario_confirmacao_id: null,
                proxima_verificacao_em: null,
                alerta_enviado_em: null,
                motivo_encerramento: null,
                monitoramento_ativo: true,
                finalizar: false
            });
            triggerRefresh(); // Atualiza a lista com filtros atuais
            closeModal();
        } catch (err) {
            console.error("Erro ao resetar solicitação:", err);
            setModalError('Falha ao resetar: ' + (err.response?.data?.detail || err.message));
        } finally {
            setIsModalLoading(false);
        }
    };

    const handleFinalizarTratamento = async () => {
        if (!selectedSolicitacao || isModalLoading || selectedSolicitacao.usuario_finalizacao_id) return;
        setIsModalLoading(true);
        setModalError('');
        console.log(`[SolicitacoesTable] Marcando solicitação ID ${selectedSolicitacao.id} como finalizada (tratada)...`);
        try {
            await updateSolicitacao(selectedSolicitacao.id, { finalizar: true });
            triggerRefresh(); // Atualiza a lista com filtros atuais
            closeModal(); // Fecha o modal após sucesso
        } catch (err) {
             console.error("Erro ao marcar como finalizado:", err);
            setModalError('Falha ao finalizar: ' + (err.response?.data?.detail || err.message));
        } finally {
             setIsModalLoading(false);
        }
    };

    const handleToggleArchive = async () => {
        if (!selectedSolicitacao || isModalLoading || !isAdmin) return;
        const newArchiveStatus = !selectedSolicitacao.is_archived;
        setIsModalLoading(true);
        setModalError('');
        setIsMenuOpen(false); // Fecha menu
        console.log(`[SolicitacoesTable] Admin ${currentUser.username} ${newArchiveStatus ? 'arquivando' : 'desarquivando'} solicitação ID ${selectedSolicitacao.id}...`);
        try {
            await archiveSolicitation(selectedSolicitacao.id, newArchiveStatus);
            triggerRefresh(); // Atualiza a lista com filtros atuais
            closeModal(); // Fecha o modal
        } catch (err) {
            console.error("Erro ao arquivar/desarquivar:", err);
            setModalError('Falha ao arquivar/desarquivar: ' + (err.response?.data?.detail || err.message));
        } finally {
            setIsModalLoading(false);
        }
    };

    const selectedPortalStatusClass = getPortalStatusClass(selectedSolicitacao?.status_portal);
    const selectedRobotStatusClass = getRobotStatusClass(
        selectedSolicitacao?.status_robo,
        selectedSolicitacao?.is_archived,
        Boolean(selectedSolicitacao?.usuario_finalizacao_id)
    );
    const selectedStatusContext = [
        selectedSolicitacao?.status_portal,
        selectedSolicitacao?.status_robo,
        selectedSolicitacao?.motivo_encerramento
    ].join(' ').toLowerCase();
    const selectedComprovantes = parseComprovantesPaths(selectedSolicitacao?.comprovantes_path);
    const canReturnToMonitoring = Boolean(
        selectedSolicitacao &&
        !selectedSolicitacao.is_archived &&
        selectedStatusContext.includes('devolvido para ajustes')
    );
    const canFinalizeWithDocuments = Boolean(
        selectedSolicitacao &&
        !selectedSolicitacao.is_archived &&
        !selectedSolicitacao.usuario_finalizacao_id &&
        selectedComprovantes.length > 0 &&
        (
            selectedStatusContext.includes('efetivad') ||
            selectedStatusContext.includes('liquid') ||
            selectedStatusContext.includes('finalizado com sucesso')
        )
    );
    const modalActionHint = canReturnToMonitoring
        ? {
            tone: 'warning',
            title: 'Depois de corrigir no portal',
            text: 'Após ajustar e reenviar esta solicitação no portal do banco, clique em Retornar ao monitoramento para o robô voltar a acompanhar o andamento.'
        }
        : canFinalizeWithDocuments
            ? {
                tone: 'success',
                title: 'Antes de concluir',
                text: 'Baixe os comprovantes, junte aos autos do processo e depois clique em Concluído para retirar esta solicitação da sua fila.'
            }
            : null;
    const selectedPrazoFatalState = getPrazoFatalState(selectedSolicitacao?.prazo_fatal_em, selectedSolicitacao?.status_robo);
    const createdByDisplay = selectedSolicitacao?.usuario_criacao?.username || 'N/A';
    const treatedByDisplay = selectedSolicitacao?.usuario_finalizacao
        ? `${selectedSolicitacao.usuario_finalizacao.username}${selectedSolicitacao.data_finalizacao ? ` em ${formatDataHora(selectedSolicitacao.data_finalizacao)}` : ''}`
        : 'Ainda não tratado';
    const archivedByDisplay = selectedSolicitacao?.is_archived
        ? `${selectedSolicitacao.usuario_arquivamento?.username || 'Admin'}${selectedSolicitacao.data_arquivamento ? ` em ${formatDataHora(selectedSolicitacao.data_arquivamento)}` : ''}`
        : 'Não arquivado';
    const internalContextItems = [
        selectedSolicitacao?.motivo_encerramento
            ? { label: 'Motivo do encerramento', value: selectedSolicitacao.motivo_encerramento }
            : null,
        selectedSolicitacao?.usuario_confirmacao?.username
            ? {
                label: 'Confirmado pelo robô',
                value: selectedSolicitacao.ultima_verificacao_robo
                    ? `${selectedSolicitacao.usuario_confirmacao.username} em ${formatDataHora(selectedSolicitacao.ultima_verificacao_robo)}`
                    : selectedSolicitacao.usuario_confirmacao.username
            }
            : null,
        selectedSolicitacao?.ultima_verificacao_robo
            ? { label: 'Última verificação', value: formatDataHora(selectedSolicitacao.ultima_verificacao_robo) }
            : null
    ].filter(Boolean);


    return (
        <div className="card process-table-container">
            <h2>Solicitações</h2>
            {/* Filtros */}
            <div className="filters-container">
                <div className="form-group">
                    <label htmlFor="filterNpj">Filtrar NPJ</label>
                    <input id="filterNpj" type="text" value={filterNpj} onChange={(e) => setFilterNpj(e.target.value)} placeholder="NPJ..." />
                </div>
                <div className="form-group">
                    <label htmlFor="filterProcesso">Filtrar Nº Processo</label>
                    <input id="filterProcesso" type="text" value={filterProcesso} onChange={(e) => setFilterProcesso(e.target.value)} placeholder="Nº Processo..." />
                </div>
                <div className="form-group">
                    <label htmlFor="filterStartDate">Data Início</label>
                    <input id="filterStartDate" type="date" value={filterStartDate} onChange={(e) => setFilterStartDate(e.target.value)} className="date-input-style"/>
                </div>
                <div className="form-group">
                    <label htmlFor="filterEndDate">Data Fim</label>
                    <input id="filterEndDate" type="date" value={filterEndDate} onChange={(e) => setFilterEndDate(e.target.value)} className="date-input-style"/>
                </div>
                <div className="form-group">
                    <label htmlFor="filterStatusBanco">Status do Banco</label>
                    <select
                        id="filterStatusBanco"
                        value={filterStatusBanco}
                        onChange={(e) => setFilterStatusBanco(e.target.value)}
                    >
                        <option value="all">Todos</option>
                        {availableStatusBanco.map((statusOption) => (
                            <option key={statusOption.value} value={statusOption.value}>
                                {statusOption.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

             <div className="table-wrapper">
                <table className="process-table">
                    <thead>
                        <tr>
                            <th className="col-npj">NPJ</th>
                            <th className="th-narrow col-numero">Nº</th> {/* Cabeçalho ajustado */}
                            <th className="th-valor col-valor">Valor</th> {/* Classe para alinhamento */}
                            <th className="col-data">Data Solicitação</th>
                            <th className="col-prazo">Prazo Fatal</th>
                            <th className="col-criado-por">Criado Por</th>
                            <th className="col-setor">Setor</th>
                            <th className="col-status-banco">Status Banco</th>
                            <th className="col-status-robo">Status Robô</th>
                            <th className="table-actions-header">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentSolicitacoes.length > 0 ? (
                            currentSolicitacoes.map(item => {
                                const statusRoboClasse = getRobotStatusClass(item.status_robo, item.is_archived, Boolean(item.usuario_finalizacao_id));
                                const statusPortalClasse = getPortalStatusClass(item.status_portal);
                                const prazoFatalState = getPrazoFatalState(item.prazo_fatal_em, item.status_robo);

                                let statusRoboText = item.status_robo || 'Pendente';
                                if (item.usuario_finalizacao) {
                                    statusRoboText = `Tratado por ${item.usuario_finalizacao.username}`;
                                } else if (item.is_archived) {
                                    statusRoboText = 'Arquivado';
                                }

                                const statusRoboTitle = item.usuario_finalizacao
                                    ? `Tratado por ${item.usuario_finalizacao.username} em ${formatDataHora(item.data_finalizacao)}`
                                    : item.is_archived
                                        ? `Arquivado por ${item.usuario_arquivamento?.username || 'Admin'} em ${formatDataHora(item.data_arquivamento)}`
                                        : item.status_robo || 'Pendente';

                                const statusPortalTitle = item.status_portal || 'Nenhum retorno do banco até o momento';
                                const prazoFatalLabel = item.prazo_fatal_em ? formatDataHora(item.prazo_fatal_em) : 'Nao definido';


                                return (
                                    <tr key={item.id} className={item.is_archived ? 'archived-row' : ''}>
                                        <td className="cell-npj">{item.npj}</td>
                                        <td className="td-narrow cell-number">{item.numero_solicitacao}</td> {/* Estilo aplicado */}
                                        <td className="td-valor cell-value">{formatValorDisplay(item.valor)}</td> {/* Estilo aplicado */}
                                        <td className="cell-date">{formatDataHora(item.data_solicitacao)}</td>
                                        <td className="cell-deadline">
                                            <span className={`deadline-chip deadline-${prazoFatalState}`} title={prazoFatalLabel}>
                                                {prazoFatalLabel}
                                            </span>
                                        </td>
                                        <td className="cell-owner">{item.usuario_criacao?.username || 'N/A'}</td>
                                        <td className="cell-sector">{getSolicitacaoSectorValue(item) || 'Sem setor'}</td>
                                        <td className="cell-status">
                                          <div className="status-cell status-cell-stacked">
                                            <span
                                              className={`status-indicator status-${statusPortalClasse}`}
                                              title={statusPortalTitle}
                                            ></span>
                                            <span className="status-text" title={statusPortalTitle}>
                                              {item.status_portal || 'Sem retorno do banco'}
                                            </span>
                                          </div>
                                        </td>
                                        <td className="cell-status">
                                          <div className="status-cell status-cell-stacked">
                                            {!item.is_archived && !item.usuario_finalizacao_id && (
                                                <span
                                                  className={`status-indicator status-${statusRoboClasse}`}
                                                  title={statusRoboTitle}
                                                ></span>
                                             )}
                                            <span className="status-text" title={statusRoboTitle}>
                                              {statusRoboText}
                                            </span>
                                          </div>
                                        </td>
                                        <td className="table-actions-cell">
                                            <button onClick={() => openModal(item)} className="action-button details-button" title="Ver Detalhes">
                                                <DetailsIcon /> {/* Ícone SVG */}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : ( <tr><td colSpan="10" className="table-empty-message">Nenhuma solicitação encontrada com os filtros aplicados.</td></tr> )}
                    </tbody>
                </table>
             </div>
             <p className="table-status-legend">
                <strong>Status Banco</strong>: ultimo retorno lido no portal do banco.{' '}
                <strong>Status Robô</strong>: etapa interna controlada pelo OneCost para monitoramento, alertas e tratamento.
             </p>

             {/* Paginação */}
             {filteredSolicitacoes.length > 0 && (
                <div className="pagination-controls">
                    <div className="pagination-config">
                        <label htmlFor="itemsPerPage" className="pagination-label">Itens por página</label>
                        <select
                            id="itemsPerPage"
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="pagination-select"
                        >
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={250}>250</option>
                        </select>
                    </div>
                    <button onClick={handlePrevPage} disabled={currentPage === 1} className="pagination-button">Anterior</button>
                    <span className="pagination-info">Página {currentPage} de {totalPages} ({filteredSolicitacoes.length} itens)</span>
                    <div className="pagination-pages" aria-label="Paginação">
                        {paginationItems.map((pageItem) => {
                            if (typeof pageItem === 'string') {
                                return <span key={pageItem} className="pagination-ellipsis">...</span>;
                            }

                            return (
                                <button
                                    key={pageItem}
                                    type="button"
                                    onClick={() => paginate(pageItem)}
                                    className={`pagination-button pagination-page-button ${pageItem === currentPage ? 'is-active' : ''}`}
                                >
                                    {pageItem}
                                </button>
                            );
                        })}
                    </div>
                    <button onClick={handleNextPage} disabled={currentPage === totalPages} className="pagination-button">Próxima</button>
                </div>
             )}

            {/* Modal Detalhes com Layout Ajustado e Botão Concluído */}
             {isModalOpen && selectedSolicitacao && createPortal(
                <div className="modal-backdrop" onClick={closeModal}>
                    <div className="modal-content modal-content-wide" onClick={e => e.stopPropagation()}>
                        <div className="modal-header">
                             <h3>Detalhes da Solicitação (ID: {selectedSolicitacao.id})</h3>
                             <div className="modal-header-actions">
                                {/* Menu Dropdown */}
                                <div className="modal-menu-container" ref={menuRef}>
                                    <button onClick={toggleMenu} className="modal-action-button modal-menu-button" title="Mais Ações" disabled={isModalLoading}>
                                        <EllipsisVerticalIcon />
                                    </button>
                                    {isMenuOpen && (
                                        <div className="modal-dropdown-menu">
                                            {/* Opção Resetar Pendente (se não arquivado) */}
                                            {!selectedSolicitacao.is_archived && (
                                                <button onClick={handleResetPendente} disabled={isModalLoading} className="dropdown-item">
                                                    {canReturnToMonitoring ? 'Retornar ao monitoramento' : 'Resetar pendente'}
                                                </button>
                                            )}
                                            {/* Opção Arquivar/Desarquivar (somente admin) */}
                                            {isAdmin && (
                                                <button onClick={handleToggleArchive} disabled={isModalLoading} className={`dropdown-item ${selectedSolicitacao.is_archived ? 'action-unarchive' : 'action-archive'}`}>
                                                    {selectedSolicitacao.is_archived ? 'Desarquivar' : 'Arquivar'}
                                                </button>
                                            )}
                                             {/* Mensagem se não houver ações */}
                                             {!isAdmin && selectedSolicitacao.is_archived && (
                                                 <span className="dropdown-item-disabled">Nenhuma ação disponível</span>
                                             )}
                                        </div>
                                    )}
                                </div>
                                {/* Botão Fechar X */}
                                <button onClick={closeModal} className="modal-action-button modal-close-icon-button" title="Fechar" disabled={isModalLoading}>
                                    <CloseIcon />
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">
                             {modalError && <p className="form-message error modal-error">{modalError}</p>}

                             <div className="modal-status-grid">
                                <div className="modal-status-card">
                                    <span className="modal-status-caption">Status do Banco</span>
                                    <span className={`modal-status-text status-${selectedPortalStatusClass}`}>
                                        {selectedSolicitacao.status_portal || 'Sem retorno do banco'}
                                    </span>
                                    <span className="modal-status-helper">Ultimo retorno visto no portal.</span>
                                </div>
                                <div className="modal-status-card">
                                    <span className="modal-status-caption">Status no OneCost</span>
                                    <span className={`modal-status-text status-${selectedRobotStatusClass}`}>
                                        {selectedSolicitacao.status_robo || 'Pendente'}
                                    </span>
                                    <span className="modal-status-helper">Situacao atual do fluxo interno.</span>
                                </div>
                                <div className="modal-status-card">
                                    <span className="modal-status-caption">Prazo Fatal</span>
                                    <span className="modal-deadline-block">
                                        <span className={`deadline-chip deadline-${selectedPrazoFatalState}`}>
                                            {selectedSolicitacao.prazo_fatal_em ? formatDataHora(selectedSolicitacao.prazo_fatal_em) : 'Nao definido'}
                                        </span>
                                    </span>
                                    <span className="modal-status-helper">Use como referencia operacional.</span>
                                </div>
                             </div>

                             {modalActionHint && (
                                <div className={`modal-callout modal-callout-${modalActionHint.tone}`}>
                                    <strong className="modal-callout-title">{modalActionHint.title}</strong>
                                    <span className="modal-callout-text">{modalActionHint.text}</span>
                                </div>
                             )}

                             <div className="modal-section">
                                <h4 className="modal-section-title">Dados Essenciais</h4>
                                <div className="modal-meta-grid">
                                    <div className="modal-meta-item">
                                        <span className="modal-label">NPJ</span>
                                        <span className="modal-meta-value">{selectedSolicitacao.npj}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Numero CNJ</span>
                                        <div className="modal-field-with-action modal-field-with-action-compact">
                                            <span className="modal-meta-value">{selectedSolicitacao.numero_processo || 'N/A'}</span>
                                            {selectedSolicitacao.numero_processo && (
                                                <button onClick={() => handleCopyToClipboard(selectedSolicitacao.numero_processo)} className="modal-copy-button" title="Copiar Nº Processo">
                                                    <CopyIcon />
                                                    {copyStatus && <span className="copy-feedback">{copyStatus}</span>}
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Tipo de Custa</span>
                                        <span className="modal-meta-value">{selectedSolicitacao.especificacao || 'N/A'}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Numero</span>
                                        <span className="modal-meta-value">{selectedSolicitacao.numero_solicitacao}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Valor</span>
                                        <span className="modal-meta-value">{formatValorDisplay(selectedSolicitacao.valor)}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Data da Solicitacao</span>
                                        <span className="modal-meta-value">{formatDataHora(selectedSolicitacao.data_solicitacao)}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Setor</span>
                                        <span className="modal-meta-value">{getSolicitacaoSectorValue(selectedSolicitacao) || 'Sem setor'}</span>
                                    </div>
                                </div>
                             </div>

                             <div className="modal-section">
                                <h4 className="modal-section-title">Responsaveis</h4>
                                <div className="modal-meta-grid modal-meta-grid-compact">
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Criado por</span>
                                        <span className="modal-meta-value">{createdByDisplay}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Tratado por</span>
                                        <span className="modal-meta-value">{treatedByDisplay}</span>
                                    </div>
                                    <div className="modal-meta-item">
                                        <span className="modal-label">Arquivamento</span>
                                        <span className="modal-meta-value">{archivedByDisplay}</span>
                                    </div>
                                </div>
                             </div>

                             <div className="modal-documents-section">
                                <div className="modal-divider-header"><hr/><span className="divider-text">DOCUMENTOS</span><hr/></div>
                                <ul className="modal-files-list">{formatComprovantes(selectedComprovantes)}</ul>
                             </div>

                             {internalContextItems.length > 0 && (
                                <div className="modal-section">
                                    <h4 className="modal-section-title">Contexto Interno</h4>
                                    <div className="modal-meta-grid modal-meta-grid-compact">
                                        {internalContextItems.map((item) => (
                                            <div key={item.label} className="modal-meta-item">
                                                <span className="modal-label">{item.label}</span>
                                                <span className="modal-meta-value">{item.value}</span>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                             )}
                        </div>
                         <div className="modal-footer">
                            {canReturnToMonitoring && (
                                <button
                                    onClick={handleResetPendente}
                                    className="button small warning"
                                    disabled={isModalLoading}
                                    title="Depois de corrigir e reenviar no portal, devolva esta solicitação para a fila do robô"
                                >
                                    {isModalLoading ? '...' : 'Retornar ao monitoramento'}
                                </button>
                            )}
                            {canFinalizeWithDocuments && (
                                <button
                                    onClick={handleFinalizarTratamento}
                                    className="button small success"
                                    disabled={isModalLoading}
                                    title="Marcar que os comprovantes já foram baixados e tratados fora do OneCost"
                                >
                                    {isModalLoading ? '...' : 'Concluído'}
                                </button>
                            )}
                        </div>
                    </div>
                </div>,
                document.getElementById('modal-root')
            )}
        </div>
    );
};



// --- COMPONENTE PRINCIPAL DA APLICAÇÃO ---
function App() {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Controla o carregamento inicial
    const [currentUser, setCurrentUser] = useState(null); // Armazena dados do usuário logado
    const [solicitacoes, setSolicitacoes] = useState([]);
    const [error, setError] = useState(''); // Erro global da aplicação
    const [isAdminModalOpen, setIsAdminModalOpen] = useState(false); // Estado do modal admin
    const [directorySectorOptions, setDirectorySectorOptions] = useState([]);

    // <<< NOVO: Estado para os filtros >>>
    const [filters, setFilters] = useState({
        includeArchived: false,
        userFilter: 'me', // 'me', 'sector' ou 'all'
        selectedSector: ''
    });

    const availableSectorOptions = useMemo(() => {
        const uniqueSectors = new Set();

        solicitacoes.forEach((solicitacao) => {
            const sectorValue = getSolicitacaoSectorValue(solicitacao);
            uniqueSectors.add(sectorValue || EMPTY_SECTOR_FILTER);
        });

        directorySectorOptions.forEach((sectorValue) => {
            const normalizedSector = String(sectorValue || '').trim();
            if (normalizedSector) {
                uniqueSectors.add(normalizedSector);
            }
        });

        return Array.from(uniqueSectors)
            .sort((left, right) => {
                if (left === EMPTY_SECTOR_FILTER) return 1;
                if (right === EMPTY_SECTOR_FILTER) return -1;
                return left.localeCompare(right, 'pt-BR');
            })
            .map((sectorValue) => ({
                value: sectorValue,
                label: sectorValue === EMPTY_SECTOR_FILTER ? 'Sem setor' : sectorValue
            }));
    }, [directorySectorOptions, solicitacoes]);

    // Função de Logout - precisa ser definida antes de ser usada no useCallback
     const handleLogout = useCallback(() => {
        console.log("[App] Executando logout...");
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setCurrentUser(null);
        setSolicitacoes([]);
        setError('');
        setFilters({ includeArchived: false, userFilter: 'me', selectedSector: '' }); // Reseta filtros no logout
        setDirectorySectorOptions([]);
        setIsLoading(false); // Garante que não fique carregando
        setIsAdminModalOpen(false); // Fecha modal admin ao deslogar
    }, []); // useCallback sem dependências


    // Função para buscar dados do usuário e solicitações
    // useCallback para evitar recriações desnecessárias, aceita filtros
    const fetchData = useCallback(async (currentFilters) => {
        console.log(`[App] Chamando fetchData... Filtros:`, currentFilters);
        setError(''); // Limpa erros antigos
        setIsLoading(true); // Inicia loading para busca
        let userToUse = currentUser; // Usa o estado atual como base

        try {
            // Se não temos usuário no estado, busca
            if (!userToUse) {
                console.log("[App] Buscando dados do usuário...");
                userToUse = await getCurrentUser();
                setCurrentUser(userToUse); // Atualiza o estado
                 if (!userToUse) { // Se ainda assim não encontrar usuário, força logout
                     console.error("[App] Não foi possível obter dados do usuário atual após tentativa.");
                     handleLogout();
                     return;
                 }
            } else {
                 console.log("[App] Usando dados do usuário do estado:", userToUse);
            }

            console.log("[App] Buscando solicitações com filtros:", currentFilters);
            const normalizedScope = userToUse.role === 'admin'
                ? 'all'
                : (currentFilters.userFilter === 'sector' ? 'sector' : 'me');
            const userIdParam = normalizedScope === 'me' ? userToUse.id : null;
            const solicitacoesResponse = await getSolicitacoes(currentFilters.includeArchived, userIdParam, normalizedScope);
            console.log("[App] Solicitações recebidas:", solicitacoesResponse);
            // Ordena por ID decrescente
            setSolicitacoes(solicitacoesResponse.sort((a, b) => b.id - a.id));
            setIsLoggedIn(true); // Confirma que está logado
        } catch (err) {
             console.error("[App] Erro detalhado em fetchData:", err);
             let detailedError = err.message || 'Verifique a conexão';
             if (err.response) {
                 detailedError = `Erro ${err.response.status}: ${err.response.data?.detail || err.message}`;
                 // O interceptor já trata o 401 para deslogar
                 if (err.response.status !== 401) { // Só mostra erro se não for 401 (já tratado)
                     setError('Erro ao buscar dados: ' + detailedError);
                 }
             } else if (err.request) {
                 detailedError = "Sem resposta do servidor.";
                 setError('Erro ao buscar dados: ' + detailedError);
             } else {
                  setError('Erro ao buscar dados: ' + detailedError);
             }
             // Se o erro não for 401, mas não temos token, desloga preventivamente
             if (!localStorage.getItem('token') && err.response?.status !== 401) {
                 handleLogout();
             }
        } finally {
             // Garante que o estado de carregamento seja desativado
             setIsLoading(false);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentUser, handleLogout]); // Recria fetchData se currentUser ou handleLogout mudar


    // Efeito para verificar o token e buscar dados iniciais
    useEffect(() => {
        console.log("[App useEffect] Verificando token...");
        const token = localStorage.getItem('token');
        if (token) {
            console.log("[App useEffect] Token encontrado. Buscando dados iniciais...");
            setIsLoading(true);
            getCurrentUser().then(user => {
                setCurrentUser(user);
                const initialFilters = {
                    includeArchived: false,
                    userFilter: user.role === 'admin' ? 'all' : 'me',
                    selectedSector: ''
                };
                setFilters(initialFilters);
                return fetchData(initialFilters);
            }).catch(err => {
                console.error("[App useEffect] Falha ao recuperar usuário inicial:", err);
                handleLogout();
            });
        } else {
            console.log("[App useEffect] Nenhum token. Indo para login.");
            setIsLoading(false); // Não está carregando se não tem token
            setIsLoggedIn(false);
            setCurrentUser(null);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // Executa apenas uma vez ao montar


    // Callback para quando o login for bem-sucedido
    const handleLoginSuccess = useCallback((loginData) => {
        console.log("[App] Login OK. Iniciando busca de dados pós-login...");
        setIsLoading(true); // Mostra carregando enquanto busca dados
        // Primeiro busca o usuário, depois busca os dados com base nele e nos filtros
        getCurrentUser().then(user => {
            const initialFilters = {
                includeArchived: false,
                userFilter: user.role === 'admin' ? 'all' : 'me',
                selectedSector: ''
            };
            setCurrentUser(user); // Define o usuário atual
            setFilters(initialFilters); // Reseta filtros no login
            return fetchData(initialFilters); // Busca as solicitações com filtros iniciais
        }).catch(err => {
            console.error("Erro pós-login ao buscar usuário:", err);
            setError("Erro ao carregar dados do usuário.");
            setIsLoading(false);
            handleLogout(); // Desloga se não conseguir buscar o usuário
        });
    }, [fetchData, handleLogout]); // Depende de fetchData e handleLogout


    // Callback para componentes filhos solicitarem atualização de dados ou mudarem filtros
    // <<< AJUSTE: Renomeado para handleFiltersChange >>>
    const handleFiltersChange = useCallback((includeArchived, userFilterValue) => {
        const nextUserFilter = userFilterValue !== undefined ? userFilterValue : filters.userFilter;
        const newFilters = {
            // Se includeArchived não for undefined, usa ele, senão mantém o atual
            includeArchived: includeArchived !== undefined ? includeArchived : filters.includeArchived,
            // Se userFilterValue não for undefined, usa ele, senão mantém o atual
            userFilter: nextUserFilter,
            selectedSector: nextUserFilter === 'sector' ? filters.selectedSector : ''
        };
        console.log(`[App] Solicitação de mudança de filtros/refresh recebida:`, newFilters);
        setFilters(newFilters); // Atualiza o estado dos filtros
        fetchData(newFilters); // Busca dados com os novos filtros
    }, [fetchData, filters]); // Depende de fetchData e do estado atual dos filtros


    // NOVO: Handler para o filtro de usuário (radio buttons)
    const handleUserFilterChange = (event) => {
        const newUserFilter = event.target.value;
        // Chama handleFiltersChange passando undefined para includeArchived para manter o valor atual
        handleFiltersChange(undefined, newUserFilter);
    };

    const handleSectorSelectionChange = (event) => {
        const nextSector = event.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            selectedSector: nextSector
        }));
    };

    useEffect(() => {
        if (currentUser?.role !== 'admin' || filters.userFilter !== 'sector' || filters.selectedSector || availableSectorOptions.length === 0) {
            return;
        }

        const preferredSector = currentUser?.setor && availableSectorOptions.some((option) => option.value === currentUser.setor)
            ? currentUser.setor
            : availableSectorOptions[0].value;

        setFilters((prevFilters) => ({
            ...prevFilters,
            selectedSector: preferredSector
        }));
    }, [availableSectorOptions, currentUser, filters.selectedSector, filters.userFilter]);

    useEffect(() => {
        if (currentUser?.role !== 'admin') {
            setDirectorySectorOptions([]);
            return;
        }

        let isMounted = true;

        getAdSectors()
            .then((sectors) => {
                if (isMounted) {
                    setDirectorySectorOptions(Array.isArray(sectors) ? sectors : []);
                }
            })
            .catch((err) => {
                console.error("[App] Falha ao carregar setores do AD:", err);
                if (isMounted) {
                    setDirectorySectorOptions([]);
                }
            });

        return () => {
            isMounted = false;
        };
    }, [currentUser?.role]);


    // Tela de Carregamento Inicial
    // Mostra se isLoading é true E (não está logado OU ainda não tem dados do currentUser)
    if (isLoading && (!isLoggedIn || !currentUser) && localStorage.getItem('token')) {
        return <div className="loading-screen">Carregando...</div>;
    }

    // Tela de Login
    if (!isLoggedIn || !currentUser) { // Verifica currentUser também
        return <LoginPage onLoginSuccess={handleLoginSuccess} />;
    }

    // Tela Principal (Dashboard)
    return (
        <div className="App main-app">
            <header className="app-header">
                <img src={logo} alt="OneSid Logo" className="logo" />
                <div className="user-info">
                    {/* Botão para abrir o modal de Admin */}
                    {currentUser?.role === 'admin' && (
                        <button onClick={() => setIsAdminModalOpen(true)} className="button admin-button" title="Painel Administrativo">
                            <AdminIcon /> Admin
                        </button>
                    )}
                    <span>Olá, {currentUser?.username} ({currentUser?.role}{currentUser?.setor ? ` - ${currentUser.setor}` : ''})</span>
                    <button onClick={handleLogout} className="button logout-button">Sair</button>
                </div>
            </header>
            <main>
                {/* Mensagem de Erro Global */}
                {error && <p className="global-error-message">{error}</p>}

                {/* Formulário de Criação de Solicitação */}
                {/* Passa a função para recarregar usando os filtros atuais */}
                <SolicitacaoForm
                    onSolicitacaoCriada={() => handleFiltersChange(filters.includeArchived, filters.userFilter)}
                    existingSolicitacoes={solicitacoes}
                    currentUser={currentUser}
                />

                 {/* <<< NOVO: Filtro de Usuário >>> */}
                 <div className="card filter-container filter-container-compact">
                     <div className="filter-container-heading">
                        <h4>Visualização</h4>
                     </div>
                     <div className="filter-scope-toolbar">
                        <div className="filter-options filter-options-segmented">
                            {currentUser?.role === 'admin' ? (
                                <>
                                    <label className={filters.userFilter === 'all' ? 'is-active' : ''}>
                                        <input
                                            type="radio"
                                            name="userFilter"
                                            value="all"
                                            checked={filters.userFilter === 'all'}
                                            onChange={handleUserFilterChange}
                                            disabled={isLoading}
                                        />
                                        Todas
                                    </label>
                                    <label className={filters.userFilter === 'sector' ? 'is-active' : ''}>
                                        <input
                                            type="radio"
                                            name="userFilter"
                                            value="sector"
                                            checked={filters.userFilter === 'sector'}
                                            onChange={handleUserFilterChange}
                                            disabled={isLoading}
                                        />
                                        Por setor
                                    </label>
                                </>
                            ) : (
                                <>
                                    <label className={filters.userFilter === 'me' ? 'is-active' : ''}>
                                        <input
                                            type="radio"
                                            name="userFilter"
                                            value="me"
                                            checked={filters.userFilter === 'me'}
                                            onChange={handleUserFilterChange}
                                            disabled={isLoading}
                                        />
                                        Minhas
                                    </label>
                                    <label className={filters.userFilter === 'sector' ? 'is-active' : ''}>
                                        <input
                                            type="radio"
                                            name="userFilter"
                                            value="sector"
                                            checked={filters.userFilter === 'sector'}
                                            onChange={handleUserFilterChange}
                                            disabled={isLoading || !currentUser?.setor}
                                        />
                                        Meu setor
                                    </label>
                                </>
                            )}
                        </div>
                        {currentUser?.role === 'admin' && filters.userFilter === 'sector' && (
                            <div className="filter-scope-select">
                                <label htmlFor="selectedSector">Setor</label>
                                <select
                                    id="selectedSector"
                                    value={filters.selectedSector}
                                    onChange={handleSectorSelectionChange}
                                    disabled={isLoading || availableSectorOptions.length === 0}
                                >
                                    {availableSectorOptions.map((sectorOption) => (
                                        <option key={sectorOption.value} value={sectorOption.value}>
                                            {sectorOption.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                     </div>
                     {/* Botão de Refresh Manual 
                     <button
                        onClick={() => handleFiltersChange(filters.includeArchived, filters.userFilter)} // Recarrega com os filtros atuais
                        disabled={isLoading}
                        className="button refresh-button"
                        title="Recarregar lista"
                     >
                        {isLoading ? '...' : '🔄'}
                     </button>*/}
                </div>

                {/* Tabela de Solicitações */}
                <SolicitacoesTable
                    solicitacoes={solicitacoes}
                    currentUser={currentUser} // Passa o usuário atual para a tabela
                    onDataRefresh={handleFiltersChange} // Passa a função de refresh/mudança de filtro
                    currentFilters={filters} // Passa os filtros atuais para a tabela usar no refresh
                />
            </main>

            {/* Renderiza o Modal Admin (ele controla a própria visibilidade) */}
            <AdminPanelModal
                currentUser={currentUser}
                // Passa a função que aceita includeArchived e userFilter
                onDataRefresh={handleFiltersChange}
                isOpen={isAdminModalOpen}
                onClose={() => setIsAdminModalOpen(false)}
            />

            <footer className="app-footer">
                OneCost v1.0 - MDR Advocacia
            </footer>
        </div>
    );
}

export default App;
